import { Typography } from '@mui/material';

import { formatNumber } from '@/app/(account)/global-settings/cost-explorer/utils/numberUtils';

interface PaginationTitleProps {
  entityLabel: string;
  selection?: {
    isAllSelected?: boolean;
    selectedRecordsCount?: number;
  };
  isLoading: boolean;
  recordsCount: number;
}

export function PaginationTitle(props: PaginationTitleProps) {
  const { entityLabel, selection, isLoading, recordsCount } = props;
  const { selectedRecordsCount, isAllSelected } = selection ?? {};

  let title = '';

  if (isLoading) {
    title = 'Loading...';
  }
  if (!isLoading) {
    if (selectedRecordsCount && selectedRecordsCount > 0) {
      title = isAllSelected
        ? `All ${selectedRecordsCount ?? 0} ${entityLabel} on this page are selected`
        : selectedRecordsCount === 1
          ? `1 ${entityLabel.slice(0, -1)} selected on this page`
          : `${selectedRecordsCount ?? 0} ${entityLabel} selected on this page`;
    } else if (recordsCount > -1) {
      title = `${formatNumber(recordsCount ?? 0, 0)} ${entityLabel} found`;
    }
  }

  return (
    <Typography
      data-testid={'pagination-title'}
      color={'var(--mui-palette-text-primary)'}
      lineHeight='24px'
      component={'span'}
      className={'ml-[12px]'}
    >
      {title}
    </Typography>
  );
}
